import styled from 'styled-components';

const ErrorBox = styled.div`
  padding: 1em 1.5em;
  border: 1px solid red;
`;

export default ErrorBox;



// WEBPACK FOOTER //
// ./src/components/ErrorBox.jsx